import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientScriptSureService } from './patient-scriptsure.service';
import * as global from '../global';

@Component({
    selector: 'app-patient-scriptsure',
    templateUrl: './patient-scriptsure.component.html',
    styleUrls: [ './patient-scriptsure.component.css' ]
})
export class PatientScriptSureComponent implements OnInit, OnDestroy {
    global = global;
    sessionToken: string = null;
    scriptSureLaunchUrl: string = null;
    isLogoutNeededOnDestroy: boolean = false;

    constructor(
        private _patientScriptSureService: PatientScriptSureService,
        private _route: ActivatedRoute,
        private _router: Router,
    ) {}

    ngOnInit() {            // Get data from query parameters
        this._route.queryParams.subscribe(params => {
            this.scriptSureLaunchUrl = params.scriptSureLaunchUrl;
            this.sessionToken = params.sessionToken;     
            this.isLogoutNeededOnDestroy = true;      
        });
    }

    ngOnDestroy() {
        if (this.isLogoutNeededOnDestroy === true) {
            this.vendorLogout();
        }
    }

    goBack() {
        const returnTo = this._route.snapshot.queryParams.returnTo || '/census';
        this._router.navigateByUrl(returnTo);
    }

    vendorLogout() {
        return this._patientScriptSureService.vendorLogout({ sessionToken: this.sessionToken });
    }

    onClose() {
        this.vendorLogout()
            .catch(error => {
            })
            .then(() => {
                this.isLogoutNeededOnDestroy = false;
                this.goBack();
            });
    }
}
